import React, { useEffect } from 'react';
import { X, Download } from 'lucide-react';
import './PDFModal.css';

const PDFModal = ({ pdfUrl, title, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div className="pdf-modal-overlay" onClick={onClose}>
      <div className="pdf-modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="pdf-modal-header">
          <span className="pdf-modal-title">{title}</span>
          <div className="pdf-modal-actions">
            <a href={pdfUrl} download className="pdf-modal-download">
              <Download size={16} />
              Descargar
            </a>
            <button className="pdf-modal-close" onClick={onClose} aria-label="Cerrar">
              <X size={20} />
            </button>
          </div>
        </div>
        <div className="pdf-modal-body">
          <iframe
            src={pdfUrl}
            title={title}
            className="pdf-modal-iframe"
          />
        </div>
      </div>
    </div>
  );
};

export default PDFModal;
